import React, {memo} from 'react';
import NameScribble from "../img/icons/name.webp";
import { animated, useSpring } from 'react-spring';

function Name() {
  const sp0 = useSpring({
    opacity: 1,
    from: { opacity: 0 }, /*, transform: "translateY(-20px)" },*/
    delay: 0
  });

  return (
    <animated.div style={sp0} id="title-name">
      <a href="kainylund.github.io"><img src={NameScribble} alt="Kai Nylund"></img></a>
    </animated.div>
  );
}

export default memo(Name);